import { useEffect, useState } from 'react'
import { Typography,  Box } from '@mui/material';
import Sumsub from '../Sumsubkyc';
import Docusign from './docusign';
import { ApiService } from '../../API/AxiosInstance';
import QuestionaireStatus from './QuestionaireStatus';
import { ShimmerSkeleton } from '../../utils/SkimmerSkeleton';
import { captureException } from '@sentry/react';
import { colors } from '../../Theme/tokens';

export default function UserVerification({docusignStatus}) {
  const [sumSubClicked, setSumSubClicked] = useState(false)
  const [docusignClicked, setDocusignClicked] = useState(false)
  const [questionaireClicked, setQuestionaireClicked] = useState(false)
  const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''
  const [loading, setLoading] = useState(false)
  const [questionaireStatusComplete, setQuestionaireStatus] = useState()

  const verifyThreeStatus = async(user_id) => {
    setLoading(true)
    try {
        const response = await  ApiService().get(`questionnaire/${user_id}/status`)
        if(response.data) {
          setQuestionaireStatus(response?.data?.completed)
          setLoading(false)
        }
        setLoading(false)
    } catch (error) {
      setLoading(false)
      captureException(error)
    }
  }

  useEffect(() => {
    if(localStorage.getItem('docusignStatus')) {
      localStorage.removeItem('docusignStatus')
    }
  },[])

  useEffect(() => {
      verifyThreeStatus(userId)
  },[])
  return (
    <Box sx={{display:"flex", flexDirection:"column", p:{xs:"10px", sm:"20px"}, gap:"20px",boxShadow: `0px 1px 5px 0px ${colors.border.card}`, mt:2, borderRadius:"16px"}}>
      <>
        {!sumSubClicked && !docusignClicked && !questionaireClicked && <> <Typography variant='h4' sx={{ fontWeight:"600", fontSize:"23px", color:colors.text.primary}}>Assess Your Risk</Typography></>}
        {!loading ? <> {!sumSubClicked && !docusignClicked && <QuestionaireStatus questionaireClicked={questionaireClicked} setQuestionaireClicked={setQuestionaireClicked} status={questionaireStatusComplete}/>}</> : <ShimmerSkeleton  sx={{width:"100%", height:"40px", mb:2}} />}

          {/* kyc */}

          {!sumSubClicked && !docusignClicked  && !questionaireClicked && <Typography variant='h4' sx={{ fontWeight:"600", fontSize:"23px", color:colors.text.primary}}>KYC Verification</Typography>}
          {!loading ? <>{!docusignClicked && !questionaireClicked &&<Sumsub sumSubClicked={sumSubClicked} setSumSubClicked={setSumSubClicked} />}</> : <ShimmerSkeleton  sx={{width:"100%", height:"40px", mb:2}} />}

          {/* Docusign */}

          {!sumSubClicked && !docusignClicked && !questionaireClicked && <Typography variant='h4' sx={{ fontWeight:"600", fontSize:"23px", color:colors.text.primary}}>Signed Documents</Typography>}
         {!loading ? <>{!sumSubClicked && !questionaireClicked &&
           <Docusign docusignClicked={docusignClicked} setDocusignClicked={setDocusignClicked} docusignStatus={docusignStatus} />}</> : <ShimmerSkeleton  sx={{ width: '157px', height: "134px", mb:2}} />}

          </>
    </Box>
  )
}
